var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WidgetNode',{staticClass:"widget-item",attrs:{"node":_vm.getWidgetNode(_vm.widget)}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }